import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from '../core/net';
import { CodeLookup } from '../actions/action-types';
import { HttpMethods } from '@codametrix/ui-common';

type CodeLookupParams = {
  tenantId: string;
  searchTerm: string;
  codeType: string;
  effectiveDate: string;
};

export const codeLookup = createAsyncThunk<
  CMx.CodeLookupResult,
  CodeLookupParams,
  { rejectValue: CMxCommonApp.SubmitError }
>(CodeLookup.LOOKUP_CODES, async (params) => {
  const lookupParams = new URLSearchParams([['tenantId', process.env.REACT_APP_DICT_TENANT_OVERRIDE ?? params.tenantId]]);

  const values = await api<CMx.CodeLookupResult>({
    endpoint: `/dictionary/code/v2?${lookupParams.toString()}`,
    init: {
      method: HttpMethods.POST
    },
    body: {
      searchTerm: params.searchTerm,
      codeType: params.codeType,
      effectiveDate: params.effectiveDate
    }
  });
  return values;
});
